export default {
  availableWhatsappTemplates() {
    return [
      {
        label: 'Nenhum',
        code: null
      },
      ...this.whatsappTemplates
    ]
  },

  selectedWhatsappTemplate() {
    if (this.template.whatsappTemplate) {
      return this.availableWhatsappTemplates.filter(template => {
        return template['value'] === this.template.whatsappTemplate
      })[0] ?? null
    }
  }
}
